export const objectGroupRoles = [
    {key: 'curator', title: 'Куратор', field: 'curator_id'},
    {key: 'foreman', title: 'Прораб', field: 'main_staff_id'},
    {key: 'access', title: 'Имеющие доступ', field: 'has_access'}
];
export function personName(user) {
    return [user.last_name, user.first_name].filter(Boolean).join(' ') || user.full_name || `Сотрудник #${user.user_id}`;
}
export function normalizeSearch(value) { return String(value || '').toLocaleLowerCase('ru').replace(/ё/g, 'е').trim(); }
export function matchesPerson(user, query) {
    const name = normalizeSearch(personName(user));
    return normalizeSearch(query).split(/\s+/).every(part => name.includes(part));
}
export function resolveUserGroup(group, process = {}, directory = []) {
    const people = [], missing = [];
    const add = (user, isAdmin) => {
        if (!user || !user.user_id || user.active === false || user.isBot === true) return;
        isAdmin = !!isAdmin || user.telegram_admin_required === true;
        const existing = people.find(person => Number(person.user_id) === Number(user.user_id));
        if (existing) existing.ChatGroups.IsAdmin = existing.ChatGroups.IsAdmin || !!isAdmin;
        else people.push({...user, ChatGroups: {IsAdmin: !!isAdmin}});
    };
    (group.users || []).forEach(user => add(user, user.ChatGroups && user.ChatGroups.IsAdmin));
    (group.object_roles || []).forEach(selected => {
        const role = objectGroupRoles.find(role => role.key === selected.role);
        if (!role) return;
        const value = process[role.field];
        const ids = role.key === 'access' ? (Array.isArray(value) ? value : []) : (value ? [value] : []);
        // Access is optional; a configured but unavailable account still needs attention.
        if (role.key === 'access' && !ids.length) return;
        let unresolved = !ids.length;
        ids.forEach(id => {
            const user = directory.find(user => Number(user.user_id) === Number(id) && user.active !== false && user.isBot !== true);
            if (user) add(user, selected.isAdmin); else unresolved = true;
        });
        if (unresolved) missing.push(role.title);
    });
    return {people, missing};
}
